import * as React from 'react';
import Styled, { css } from 'styled-components';

import SvgIconLoading from '../../../images/icons/IconLoading_t2_';
import { rotation } from '../Animations/Animations';
import { cssDeclaration, makeMediaStyles } from '../Utils';

export const LoadingSpinner = Styled(({ size, ...rest }) => <SvgIconLoading focusable='false' {...rest} />)`
  line-height: 0;
  animation: ${rotation} 850ms linear infinite;

  ${({ theme: { themeTwo }, size }) => css`
    width: ${themeTwo.spinner.size};
    height: ${themeTwo.spinner.size};

    /* overrides theme size */
    ${size && css`
      /* width */ ${makeMediaStyles('width', size)};
      /* height */ ${makeMediaStyles('height', size)};
    `}

    /*
      when themeTwo.spinner.withOutline = true; animatedOutline = transparent
      which gives the illusion that circleOutline is animated
    */
    #loading-circle-outline {
      /* stroke */ ${cssDeclaration(themeTwo, 'stroke', themeTwo.spinner.color.circleOutline)}
    }

    ${themeTwo.spinner.withOutline ? css`
      #animation-outline {
        /* stroke */ ${cssDeclaration(themeTwo, 'stroke', themeTwo.spinner.color.animatedOutline)}
      }`
    :
      css`color: transparent;`
    }
  `}
`;
